import DataTable from '@/components/DataTable';
import { RawDataTimeSeries } from '@/components/RawData';
import { SWS_HOST } from '@/constants';

export interface Props {
  analystCount: number;
  companyShortName: string;
  futureEPSEstimates: { dateKey: number; data: number[] }[];
  lastEarningsUpdate: number;
  pastEPS: { dateKey: number; data: number[] }[];
  reportingCurrencyISO: string;
  uniqueSymbol: string;
}

const futureEPSEstimatesHeaders = [
  'EPS *',
  'EPS High Estimate',
  'EPS Low Estimate',
  'Avg. No. Analysts',
];

const pastEPSHeaders = ['EPS *'];

const EarningsPerShareGrowthRawData = ({
  uniqueSymbol,
  reportingCurrencyISO,
  lastEarningsUpdate,
  analystCount,
  companyShortName,
  futureEPSEstimates,
  pastEPS,
}: Props) => {
  return (
    <>
      <DataTable columnWidths="2, 4, 2" light>
        <caption>{`${uniqueSymbol} Past and Future Earnings per Share`}</caption>
        <thead>
          <tr>
            <th>Data Point</th>
            <th>Source</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Past Financials</td>
            <td>
              {`Company Filings (${new Date(
                lastEarningsUpdate
              ).toLocaleDateString()})`}
            </td>
            <td>See Below</td>
          </tr>
          <tr>
            <td>Future Estimates</td>
            <td>
              {`Up to ${analystCount} Analyst Estimates on Average (S&P Global)`}
            </td>
            <td>See Below</td>
          </tr>
        </tbody>
      </DataTable>
      <p>
        <span>
          {`All data from ${companyShortName} Company Filings, last reported ${new Date(
            lastEarningsUpdate
          ).toLocaleDateString()}, and in `}
        </span>
        <a
          href={`${SWS_HOST}/help/articles/hc/en-us/articles/115006170908-Why-is-some-of-the-data-on-Simply-Wall-St-different-to-other-site`}
          data-unique-symbol={uniqueSymbol}
          data-about-section="past_future_earnings"
          data-link-name="zendesk_ttm"
          target="_blank"
          rel="noopener noreferrer"
        >
          trailing twelve months (TTM)
        </a>
        <span> annual period rather than quarterly.</span>
      </p>
      <RawDataTimeSeries
        uniqueSymbol={uniqueSymbol}
        title="Future Estimates Data"
        reportingCurrencyISO={reportingCurrencyISO}
        numberPrecision={2}
        tableHeaderDescriptions={futureEPSEstimatesHeaders}
        tableData={futureEPSEstimates}
      />
      <p> </p>
      <RawDataTimeSeries
        uniqueSymbol={uniqueSymbol}
        title="Past Financials Data"
        reportingCurrencyISO={reportingCurrencyISO}
        numberPrecision={2}
        tableHeaderDescriptions={pastEPSHeaders}
        tableData={pastEPS}
      />
      <p>*GAAP earnings excluding extraordinary items.</p>
    </>
  );
};

export default EarningsPerShareGrowthRawData;
